export const SET_DRIVER_ID = 'SET_DRIVER_ID';

export const setDriverId = driverId => {
  return {
    type: SET_DRIVER_ID,
    driverId,
  };
};



// WEBPACK FOOTER //
// ./src/actions/drivers.js